/** Format a Date as YYYY-MM-DD in local time (not UTC). */
export function localDateStr(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** Today's date string in local time. */
export function todayStr() {
  return localDateStr(new Date());
}

/** Yesterday's date string in local time. */
export function yesterdayStr() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return localDateStr(d);
}
